module.exports = __webpack_public_path__ + "img/Taucherin.13fa82fa.jpg";